import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { Api } from '../api/api';
import { environment } from '../environment';
import { LayerService } from '../services/layer.service';
import * as i0 from "@angular/core";
import * as i1 from "../api/api";
import * as i2 from "./layer.service";
var PetlService = /** @class */ (function () {
    function PetlService(api, authService, layerService) {
        this.api = api;
        this.authService = authService;
        this.layerService = layerService;
        this.currentView = 'start';
        this.currentViewChange = new Subject();
        this.customTypes = ['char', 'num', 'date', 'url'];
        this.directiveTemplateBasePath = '';
        this.fileExtension = null;
        this.fileUploaded = new EventEmitter();
        this.loading = null;
        this.nonNormalViews = ['about', 'manage-projects'];
        this.previousView = '';
        this.showHelp = false;
        // List of restricted aliases, since they can conflict with the Mapcore Identify code. Note that these only conflict when the alias entered is all uppercase.
        this.restrictedAliases = ['BEGIN OFFSET', 'BEGIN SEGMENT', 'COUNTY', 'CTY_CODE', 'END OFFSET', 'END SEGMENT', 'JURIS', 'JURISDICTION', 'LONGITUDE', 'LATITUDE', 'OBJECTID', 'PROJECT ID', 'ROUTE', 'SEG_BGN', 'SEG_END', 'ST_RT_NO'];
    }
    PetlService.prototype.initialize = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (!this.initialized) {
                    this.startOver();
                    this.authService.GetCurrentUser().subscribe(function (user) {
                        _this.user = user;
                    });
                    this.initialized = true;
                }
                return [2 /*return*/];
            });
        });
    };
    PetlService.prototype.setupLayerEvents = function (mapView) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layers;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                layers = mapView.map.allLayers;
                layers.on('change', function (event) {
                    _this.onLayerChange(event);
                });
                return [2 /*return*/];
            });
        });
    };
    PetlService.prototype.onLayerChange = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, e_2, _b, _c, _d, layer, petlLayer, mapcoreProps, projectNumber, urlParams, petlProject, columnAliases, newColumnList, _loop_1, _e, _f, column, e_1_1;
            return tslib_1.__generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!(event && event.added && event.added.length > 0)) return [3 /*break*/, 8];
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 6, 7, 8]);
                        _c = tslib_1.__values(event.added), _d = _c.next();
                        _g.label = 2;
                    case 2:
                        if (!!_d.done) return [3 /*break*/, 5];
                        layer = _d.value;
                        petlLayer = environment.layers.filter(function (x) { return x.name === 'petl'; })[0];
                        mapcoreProps = layer.mapcoreProps;
                        if (!(mapcoreProps && (mapcoreProps.parentId === petlLayer.id || mapcoreProps.isPETL) && mapcoreProps.columns)) return [3 /*break*/, 4];
                        if (!(mapcoreProps.query && mapcoreProps.query.field && mapcoreProps.query.field.toLowerCase() === 'project_no')) return [3 /*break*/, 4];
                        projectNumber = mapcoreProps.query.value;
                        urlParams = ['petl', 'projects', projectNumber.toLowerCase()];
                        return [4 /*yield*/, this.petlHttpRequest(urlParams, { method: 'GET' }, 'Retreive PETL Project Info')];
                    case 3:
                        petlProject = _g.sent();
                        columnAliases = petlProject.columnAliases;
                        newColumnList = [];
                        _loop_1 = function (column) {
                            var keepColumnInList = true;
                            var petlColumnAliasesFound = columnAliases.filter(function (x) { return x.columnName.toLowerCase() === column.name.toLowerCase(); });
                            if (petlColumnAliasesFound.length) {
                                {
                                    var columnAlias = petlColumnAliasesFound[0];
                                    column.alias = columnAlias.aliasName;
                                    keepColumnInList = columnAlias.isUsed;
                                }
                            }
                            if (keepColumnInList) {
                                newColumnList.push(column);
                            }
                        };
                        try {
                            for (_e = tslib_1.__values(mapcoreProps.columns), _f = _e.next(); !_f.done; _f = _e.next()) {
                                column = _f.value;
                                _loop_1(column);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        mapcoreProps.columns = newColumnList;
                        _g.label = 4;
                    case 4:
                        _d = _c.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _g.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    PetlService.prototype.addProjectToMap = function (project) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var existingProjectLayers, layerSettings;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                existingProjectLayers = this.layerService.mapLayers.mapImage.filter(function (layer) {
                    var layerMatches = false;
                    if (layer.mapcoreProps && layer.mapcoreProps.query) {
                        layerMatches = _this.queryMatches(layer.mapcoreProps.query, project.id.toString());
                    }
                    return layerMatches;
                });
                if (existingProjectLayers.length) {
                    this.layerService.refreshLayers();
                }
                else {
                    layerSettings = this.getProjectLayerSettings(project);
                    layerSettings.zoomToLayer = this.zoomToLayer;
                    this.layerService.addMapcoreLayersToMap([layerSettings]);
                }
                return [2 /*return*/];
            });
        });
    };
    PetlService.prototype.queryMatches = function (query, projectId) {
        var e_3, _a;
        var retVal = false;
        if (query.field && (query.field.toLowerCase() === 'project_no' && query.value.toString() === projectId)) {
            retVal = true;
        }
        else if (query.subqueries) {
            try {
                for (var _b = tslib_1.__values(query.subqueries), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var sq = _c.value;
                    if (this.queryMatches(sq, projectId)) {
                        retVal = true;
                        break;
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        return retVal;
    };
    PetlService.prototype.getProjectLayerSettings = function (project) {
        return {
            id: environment.layers.find(function (x) { return x.name === 'petl'; }).id,
            query: { field: 'project_no', operator: '=', value: project.id.toString() },
            name: project.description,
            isPETL: true
        };
    };
    PetlService.prototype.getProjectList = function (updateLoading) {
        if (updateLoading === void 0) { updateLoading = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var urlParams, projectList;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        urlParams = ['petl', 'projects-by-user'];
                        return [4 /*yield*/, this.petlHttpRequest(urlParams, { method: 'GET' }, 'Retreive Projects', updateLoading)];
                    case 1:
                        projectList = _a.sent();
                        this.projectList = projectList;
                        return [2 /*return*/, projectList];
                }
            });
        });
    };
    PetlService.prototype.renewProject = function (project) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var urlParams;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        urlParams = ['petl', 'projects', 'renew', project.id.toString()];
                        return [4 /*yield*/, this.petlHttpRequest(urlParams, { method: 'GET' })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PetlService.prototype.deleteProject = function (project) {
        if (project === void 0) { project = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var urlParams;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!project) {
                            project = this.project;
                        }
                        urlParams = ['petl', 'projects', project.id.toString()];
                        return [4 /*yield*/, this.petlHttpRequest(urlParams, { method: 'DELETE' })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PetlService.prototype.processFileDrop = function (ev) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var file;
            return tslib_1.__generator(this, function (_a) {
                ev.preventDefault();
                if (this.isValidFileDrop(ev)) {
                    file = ev.dataTransfer.files[0];
                    this.sendFile(file);
                }
                return [2 /*return*/];
            });
        });
    };
    PetlService.prototype.sendFile = function (inputFile) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fileName, extension, extensionsAllowed, file, urlParams, preprocessResult, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        this.changeView('processor');
                        this.errorMessage = null;
                        this.loading = true;
                        fileName = inputFile.name;
                        extension = this.getFileExtension(fileName);
                        extensionsAllowed = ['.txt', '.csv', '.xls', '.xlsx'];
                        if (!extension || extensionsAllowed.indexOf(extension.toLowerCase()) < 0) {
                            return [2 /*return*/];
                        }
                        if (!this.visible) {
                            this.resetVariables();
                        }
                        file = inputFile;
                        this.fileName = fileName;
                        this.fileDropped = true;
                        this.visible = true;
                        this.errorMessage = '';
                        this.showRepeatFileNameIndicator = false;
                        this.showRepeatFileHeaderIndicator = false;
                        this.columnData = null;
                        urlParams = [];
                        urlParams.push('petl/filepreprocess');
                        urlParams.push(this.fileId);
                        urlParams.push(this.fileName);
                        urlParams.push(this.sheetNumber);
                        urlParams.push(this.startingRowNumber || 0);
                        return [4 /*yield*/, this.petlHttpRequest(urlParams, { file: file }, 'Uploading file', false)];
                    case 1:
                        preprocessResult = _a.sent();
                        return [4 /*yield*/, this.setFilePreProcessResults(preprocessResult)];
                    case 2:
                        result = _a.sent();
                        this.fileUploaded.emit(preprocessResult);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    PetlService.prototype.sendProcessForm = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var keepPreviousScenarios, urlParams, fileProcessResult;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.changeView('validate');
                        this.errorMessage = null;
                        this.project = input.project;
                        this.validationSubmitted = true;
                        this.promoteErrorOccurred = false;
                        this.errorMessage = '';
                        keepPreviousScenarios = input.append || input.advanced;
                        urlParams = [];
                        urlParams.push('petl/fileprocess/columnmapping');
                        urlParams.push(this.project.id);
                        if (input.scenario.id) {
                            urlParams.push(input.scenario.id);
                        }
                        else {
                            urlParams.push(0);
                        }
                        urlParams.push(input.scenario.description);
                        urlParams.push(this.fileId);
                        urlParams.push(this.fileName);
                        urlParams.push(this.fileExtension);
                        urlParams.push(this.sheetNumber);
                        urlParams.push(this.startingRowNumber || 0);
                        urlParams.push(keepPreviousScenarios);
                        this.project.stagePointCount = null;
                        this.project.stagePointCount = null;
                        return [4 /*yield*/, this.petlHttpRequest(urlParams, { method: 'POST', body: this.columnMapping }, 'Processing Mapping')];
                    case 1:
                        fileProcessResult = _a.sent();
                        this.showResultsStats = true;
                        this.validationResults = fileProcessResult;
                        this.validationReport = fileProcessResult.report;
                        this.project = fileProcessResult.project;
                        return [2 /*return*/, fileProcessResult];
                }
            });
        });
    };
    PetlService.prototype.addOrUpdateProject = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.project.userId = this.user.id;
                        if (!this.project.id) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateProject(this.project)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.addProject(this.project)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PetlService.prototype.getProject = function (projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var urlParams, newProject;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        urlParams = ['petl/projects', projectId.toString()];
                        return [4 /*yield*/, this.petlHttpRequest(urlParams, { method: 'GET' }, 'Retrieving Project')];
                    case 1:
                        newProject = _a.sent();
                        return [2 /*return*/, newProject];
                }
            });
        });
    };
    PetlService.prototype.addProject = function (projectToCreate) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, newProject;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = 'petl/projects/add';
                        return [4 /*yield*/, this.petlHttpRequest([url], { method: 'PUT', body: projectToCreate }, 'Adding new Project')];
                    case 1:
                        newProject = _a.sent();
                        this.project = newProject;
                        return [2 /*return*/, newProject];
                }
            });
        });
    };
    PetlService.prototype.updateProject = function (projectToUpdate) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var urlParams, updatedProject;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        urlParams = ['petl/projects', projectToUpdate.id.toString()];
                        return [4 /*yield*/, this.petlHttpRequest(urlParams, { method: 'POST', body: projectToUpdate }, 'Updating Project')];
                    case 1:
                        updatedProject = _a.sent();
                        return [2 /*return*/, updatedProject];
                }
            });
        });
    };
    PetlService.prototype.redefineStartingRowNumberInternal = function (isNewSheet) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var uploadInfo, urlParams, preprocessResult;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.errorMessage = null;
                        uploadInfo = this.getUploadInfo();
                        if (isNewSheet) {
                            this.columnData = null;
                        }
                        urlParams = [];
                        urlParams.push('petl/redefine-starting-row-number');
                        return [4 /*yield*/, this.petlHttpRequest(urlParams, { method: 'POST', body: uploadInfo }, 'Setting a new Start Row Number')];
                    case 1:
                        preprocessResult = _a.sent();
                        this.setNewStartingRowNumberResults(preprocessResult, isNewSheet);
                        return [2 /*return*/, preprocessResult];
                }
            });
        });
    };
    PetlService.prototype.promoteData = function (project) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var runPromoteInBatchMode, urlParams, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.changeView('promoted');
                        this.errorMessage = null;
                        runPromoteInBatchMode = !this.promoteErrorOccurred;
                        urlParams = ['petl', 'fileprocess', 'promotedata', project.id.toString(), runPromoteInBatchMode.toString()];
                        this.project.pointCount = null;
                        this.project.lineCount = null;
                        _a = this;
                        return [4 /*yield*/, this.petlHttpRequest(urlParams, { method: 'GET' }, 'Promoting Data')];
                    case 1:
                        _a.project = _b.sent();
                        this.complete.emit(this.project);
                        return [2 /*return*/, project];
                }
            });
        });
    };
    PetlService.prototype.petlHttpRequest = function (urlParams, config, whatIsHappening, updateLoading) {
        if (whatIsHappening === void 0) { whatIsHappening = ''; }
        if (updateLoading === void 0) { updateLoading = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (updateLoading) {
                            this.loading = true;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.api.http2.request(urlParams.join('/'), config)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        e_4 = _a.sent();
                        this.setErrorMessage("Error While " + whatIsHappening);
                        this.loading = false;
                        throw e_4;
                    case 4:
                        if (updateLoading) {
                            this.loading = false;
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    PetlService.prototype.resetAutomatedColumnMapping = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.startingRowNumber = null;
                        return [4 /*yield*/, this.redefineStartingRowNumberInternal(true)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PetlService.prototype.redefineStartingRowNumber = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.redefineStartingRowNumberInternal(false)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PetlService.prototype.startOver = function () {
        this.loading = false;
        this.resetVariables();
        this.changeView('start');
    };
    PetlService.prototype.goBackToMapping = function () {
        this.changeView('processor');
        this.validationSubmitted = false;
        this.showResultsStats = false;
        this.promoteDataSubmitted = false;
        this.promoteDataFinished = false;
        this.errorMessage = null;
    };
    PetlService.prototype.isValidFileDrop = function (dragEvent) {
        var e_5, _a;
        if (dragEvent.dataTransfer.files && dragEvent.dataTransfer.files.length) {
            var file = dragEvent.dataTransfer.files[0];
            var validFileExtensions = ['.txt', '.csv', '.xls', '.xlsx'];
            try {
                for (var validFileExtensions_1 = tslib_1.__values(validFileExtensions), validFileExtensions_1_1 = validFileExtensions_1.next(); !validFileExtensions_1_1.done; validFileExtensions_1_1 = validFileExtensions_1.next()) {
                    var extension = validFileExtensions_1_1.value;
                    if (file.name.toLocaleLowerCase().endsWith(extension)) {
                        return true;
                    }
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (validFileExtensions_1_1 && !validFileExtensions_1_1.done && (_a = validFileExtensions_1.return)) _a.call(validFileExtensions_1);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
        return false;
    };
    PetlService.prototype.getUploadInfo = function () {
        var uploadInfo = {};
        uploadInfo.userId = this.user.id;
        uploadInfo.fileId = this.fileId;
        uploadInfo.fileName = this.fileName;
        uploadInfo.sheetNumber = this.sheetNumber;
        uploadInfo.startingRowNumber = this.startingRowNumber || 0;
        uploadInfo.ignorePreviousColumnMappings = this.ignorePreviousColumnMappings;
        return uploadInfo;
    };
    PetlService.prototype.resetAliases = function () {
        var e_6, _a, e_7, _b;
        if (!this.project || !this.project.columnAliases || !this.results || !this.results.unusedDatabaseFields) {
            return;
        }
        try {
            for (var _c = tslib_1.__values(this.results.unusedDatabaseFields), _d = _c.next(); !_d.done; _d = _c.next()) {
                var databaseField = _d.value;
                this.resetAlias(databaseField);
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_6) throw e_6.error; }
        }
        try {
            for (var _e = tslib_1.__values(this.columnData), _f = _e.next(); !_f.done; _f = _e.next()) {
                var databaseField = _f.value;
                this.resetAlias(databaseField);
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_7) throw e_7.error; }
        }
    };
    PetlService.prototype.resetAlias = function (databaseField) {
        if (databaseField) {
            databaseField.aliasName = null;
        }
    };
    PetlService.prototype.updateColumnAliasesFromProject = function () {
        var e_8, _a, e_9, _b;
        if (!this.project || !this.project.columnAliases) {
            return;
        }
        try {
            for (var _c = tslib_1.__values(this.project.columnAliases), _d = _c.next(); !_d.done; _d = _c.next()) {
                var columnAlias = _d.value;
                try {
                    for (var _e = tslib_1.__values(this.columnData), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var cd = _f.value;
                        var databaseField = cd.databaseField;
                        this.setAliasName(databaseField, columnAlias);
                    }
                }
                catch (e_9_1) { e_9 = { error: e_9_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_9) throw e_9.error; }
                }
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_8) throw e_8.error; }
        }
    };
    PetlService.prototype.setAliasName = function (databaseField, columnAlias) {
        if (databaseField) {
            if (columnAlias.columnName.toLowerCase() === databaseField.databaseName) {
                databaseField.aliasName = columnAlias.aliasName;
            }
        }
    };
    PetlService.prototype.resetVariables = function () {
        this.columnData = null;
        this.columnHeadings = null;
        this.columnHeadingsValidated = null;
        this.columnMapping = null;
        this.errorMessage = null;
        this.fileDropped = false;
        this.fileExtension = null;
        this.fileId = 0;
        this.fileSample = null;
        this.ignorePreviousColumnMappings = false;
        this.project = null;
        this.promoteDataFinished = false;
        this.promoteDataSubmitted = false;
        this.results = null;
        this.sheetNumber = 0;
        this.showColumnMapping = false;
        this.showRepeatFileHeaderIndicator = false;
        this.showRepeatFileNameIndicator = false;
        this.showResultsStats = false;
        this.startingRowNumber = null;
        this.validationReport = null;
        this.validationResults = null;
        this.validationSubmitted = false;
    };
    PetlService.prototype.setFilePreProcessResults = function (filePreprocessResult) {
        this.preProcessResult = filePreprocessResult;
        this.results = filePreprocessResult;
        this.fileId = filePreprocessResult.fileId;
        this.startingRowNumber = filePreprocessResult.startingRowNumber;
        this.sheetNumber = filePreprocessResult.sheetNumber;
        this.sheetCount = filePreprocessResult.sheetCount;
        this.fileExtension = filePreprocessResult.fileExtension;
        this.fileSample = filePreprocessResult.fileSample;
        this.columnMapping = filePreprocessResult.columnMapping;
        this.showRepeatFileNameIndicator = filePreprocessResult.containsPreviousMapping;
        this.resultContainedPreviousMapping = filePreprocessResult.containsPreviousMapping;
        this.mappingsFromServerAltered = false;
        if (!this.showRepeatFileNameIndicator) {
            var previousColumnHeadingsValidatedString = this.columnHeadingsValidated !== null ? this.columnHeadingsValidated.toString() : '';
            this.columnHeadings = filePreprocessResult.columnHeadings;
            var newColumnHeadingsString = this.columnHeadings.toString();
            this.showRepeatFileHeaderIndicator = previousColumnHeadingsValidatedString === newColumnHeadingsString;
        }
        this.columnData = filePreprocessResult.columnData;
        this.showColumnMapping = true;
    };
    PetlService.prototype.setNewStartingRowNumberResults = function (result, newSheet) {
        var e_10, _a;
        this.columnHeadings = result.columnHeadings;
        this.fileSample = result.fileSample;
        if (newSheet) {
            this.results = result;
            this.columnData = result.columnData;
            this.mappingsFromServerAltered = false;
            this.resultContainedPreviousMapping = result.containsPreviousMapping;
            this.startingRowNumber = result.startingRowNumber;
        }
        else if (this.columnData) {
            try {
                for (var _b = tslib_1.__values(this.columnData.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = tslib_1.__read(_c.value, 2), index = _d[0], cd = _d[1];
                    cd.nativeHeader = '';
                    if (cd && result.columnData.length > index) {
                        cd.nativeHeader = result.columnData[index].nativeHeader;
                    }
                }
            }
            catch (e_10_1) { e_10 = { error: e_10_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_10) throw e_10.error; }
            }
        }
    };
    PetlService.prototype.changeView = function (viewName) {
        if (!viewName) {
            if (this.previousView) {
                viewName = this.previousView;
            }
            else {
                viewName = 'start';
            }
        }
        this.showHelp = false;
        if (this.nonNormalViews.indexOf(this.currentView) < 0 && this.currentView !== viewName) {
            this.previousView = this.currentView;
        }
        this.currentView = viewName;
        this.currentViewChange.next(this.currentView);
    };
    PetlService.prototype.toggleView = function (viewName) {
        if (this.currentView === viewName) {
            this.changeView(this.previousView);
        }
        else {
            this.changeView(viewName);
        }
    };
    PetlService.prototype.close = function () {
        this.petlClose.emit(true);
    };
    PetlService.prototype.setErrorMessage = function (errorMessage, data) {
        if (data === void 0) { data = null; }
        this.errorMessage = errorMessage;
        if (data && data.status && data.status.message) {
            this.errorMessage = this.errorMessage + ": " + data.status.message;
        }
        this.loading = false;
    };
    PetlService.prototype.getFileExtension = function (fileName) {
        if (fileName === void 0) { fileName = null; }
        if (!fileName) {
            fileName = this.fileName;
        }
        return fileName.substr(fileName.lastIndexOf('.'));
    };
    PetlService.ngInjectableDef = i0.defineInjectable({ factory: function PetlService_Factory() { return new PetlService(i0.inject(i1.Api), i0.inject("authenticationService"), i0.inject(i2.LayerService)); }, token: PetlService, providedIn: "root" });
    return PetlService;
}());
export { PetlService };
